import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  byTaskId: {},      // { 7: true, 3770: false, ... }  effective values
  stubEnabled: false,
  loaded: false,
  loading: false,
  error: null,
};

export const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    startLoad: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadSucceeded: (state, action) => {
      // payload: { byTaskId, stubEnabled }
      state.byTaskId = action.payload.byTaskId || {};
      state.stubEnabled = !!action.payload.stubEnabled;
      state.loaded = true;
      state.loading = false;
      state.error = null;
    },
    loadFailed: (state, action) => {
      state.loading = false;
      state.loaded = true; // still mark loaded so consumers don't spin forever
      state.error = action.payload || "unknown";
    },
    flagSet: (state, action) => {
      // payload: { taskId, enabled }  — optimistic update after toggle
      state.byTaskId[action.payload.taskId] = !!action.payload.enabled;
    },
    stubModeSet: (state, action) => {
      // payload: enabled
      state.stubEnabled = !!action.payload;
    },
    reset: () => initialState,
  },
});

export const { actions, reducer } = featureFlagsSlice;
